import { BlankState } from '@domain-group/suit-theme'

import BlankStateImageUrl from './assets/no-orders.svg'

const OrdersBlankState = () => (
  <BlankState boxProps={{ marginBottom: 'large' }} imageUrl={BlankStateImageUrl}>
    <BlankState.Title>No Pending Orders</BlankState.Title>

    <BlankState.Paragraph>
      This campaign doesn&apos;t have any pending orders. You can create orders by adding a new order item to your
      campaign or by approving a pending quote.
    </BlankState.Paragraph>
  </BlankState>
)

export default OrdersBlankState
